import React from 'react';
const Check = props => {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      {/* eslint-disable-next-line max-len, no-useless-escape */}
      <path d="M15.43 4.9l1.3 1.37-7.85 8.27c-.34.35-.79.55-1.26.56-.49 0-.96-.2-1.3-.56l-3.06-3.19 1.3-1.38 3.02 3.2 7.85-8.27z" />
    </svg>
  );
};
export default Check;
